class GameScene extends Phaser.Scene
{
	constructor()
	{
		super({ key: "gameScene" });

		this.gameState = -1; // -1=init 0=play 1=win 2=die 3=notification
		this.gameStateAt = 0;
		this.gameStateInfo = null;

		this.levelLeft = 0;
		this.levelTop = 50;
		this.levelNumber = 0;
		this.levelData = null;
		this.levelWidth = 0;
		this.levelHeight = 0;
		this.destroyAt = 0;

		this.player = null;
		this.things = null;
		this.platformEmitter = null;
		this.cursors = null;
		this.notificationPopup = null;
		this.lastNotificationIndex = 0;
		this.parameter = null;
		this.model = null;
		this.speakerIcon = null;

		this.notificationList = [
			[ 1, 0, 0, 18, "Would you like a stereotyped\nbackground story? Great!\nOnce upon a time there was an astronaut.\nWhile he's wandering on the Moon,\nall of a sudden 'Mars Attacks!'\nbecomes a reality!\n\nFriendly aliens arrive from Mars\n(the planet, not the chocolate)\nwho incidentally burn the Moon to dust.\nYes. Even more dust.\n\nThey are very kind with the lone survivor\n– You! –\nbecause they don't constrict the leash\non your neck very tightly.\n\n(Press SPACE or ENTER or click OK.)" ],
			[ 1, 0, 0, 10, "Moreover, they take you with them\nto let you see their world\nand be a good pet.\n\nWith sleek cast of mind, brilliant logic\nand finesse you are able to escape.\n\n(Actually your cell door opens\nby a short circuit,\nbut the other sounds better.)" ],
			[ 1, 0, 0, 4, "After escaping the prison you decide to\nescape from the planet too.\n\nBut that spaceship is far far away..." ],
			[ 1, 0, 0, 3, "Move with the cursor keys or with the pointer.\nPress the RIGHT button\nafter closing this dialog." ],
			[ 1, 1, 0, 3, "Cool! That platform disappeared!\nYour task is to remove all tiles and then\nmove to the exit to finish the level." ],
			[ 2, 1, 0, 2, "These new are stronger platforms.\nYou have to touch them twice to disappear." ],
			[ 3, 1, 0, 3, "Unbreakable platforms?\nYes. You can touch them any times\nand you can leave them there." ],
			[ 4, 2, 1, 4, "Uh-oh! That's the hungry prison guard!\nDon't deal with it now.\n\nYou will see many of them later..." ],
			[ 5, 2, 5, 3, "Those platforms seem to be slippery.\nYou have to remove them too,\nbut you can not stop on them." ],
			[ 8, 1, 3, 4, "That is a teleport crystal\nin the corner.\nIt moves those one-eyes\nout of your way." ],
			[ 30, 2, 7, 3, "You are totally sure that\nthis elevator will bring you\nto the spaceship." ]
		];
		this.levelList = [
			[ // 01 Start
				"@--*"
			],
			[ // 02 Tutorial: Double
				"--@",
				"== ",
				" * "
			],
			[ // 03 Tutorial: Fix
				"@- ",
				" - ",
				"-#-",
				"#- ",
				" -*"
			],
			[ // 04 Tutorial: Enemies 1
				"###W#",
				"  -  ",
				"@-=-*"
			],
			[ // 05 Tutorial: Ice
				" -i--",
				" *  i",
				"-i=#i",
				"i i i",
				"-i=i-",
				"  -  ",
				"  @  "
			],
			[ // 06 Ron 3: Fire and Ice
				"-f-f-f-f",
				"i      -",
				"- -i-f i",
				"i -  - -",
				"- i -f i",
				"i - f* -",
				"- i    f",
				"@ f-iif-"
			],
			[ // 07 Ron 4: Pyramid
				"   *   ",
				"  f=f  ",
				" -=ff- ",
				"@-iii=-"
			],
			[ // 08 Tutorial: Enemies 2
				"*-ee",
				"-e-e",
				"e==e",
				"@-=%"
			],
			[ // 09 round
				"-i-i-i-",
				"-     -",
				"- -%- -",
				"- e f -",
				"=====*@"
			],
			[ // 10 Ron 1
				" ----",
				" -  -",
				"#w #w",
				" -- -",
				" -- *",
				" -   ",
				" ---@"
			],
			[ // 11 Ron 2
				"=-- -   ",
				"= w####*",
				"-       ",
				"=  ##W##",
				"=--- - -",
				"       -",
				" ####W##",
				"   @ ---"
			],
			[ // 12 Walkers and Double Fires
				"@ --*",
				"-W- F",
				"- - =",
				"-W- F",
				"-i- =",
				"==- f"
			],
			[ // 13 Remote Switch
				"@-----",
				"-i=e -",
				"i ----",
				"=-=e--",
				"- e--e",
				" e*--%"
			],
			[ // 14 Slippery and Doubles
				"----  ",
				"-ii-i@",
				"i==i- ",
				"==  i-",
				"*=i-==",
				" ==-  "
			],
			[ // 15 Simple
				"   ---w ",
				"  ------",
				"@*-f -i-",
				"------- ",
				"-f-e--- ",
				" -----  ",
				"  -i-%  "
			],
			[ // 16 Tie Fighter
				"-     -",
				"=     =",
				"= --* =",
				"F==@==F",
				"= f-f =",
				"=     =",
				"-     -"
			],
			[ // 17 Crown
				"f f f",
				"=-=-=",
				"- - -",
				"--=--",
				"-i@i*",
				"-- --"
			],
			[ // 18 Trap
				" -i--",
				"-- --",
				"---i-",
				"  *w#",
				"  -==",
				"   @ "
			],
			[ // 19 Face
				" -f--f- ",
				"--E--E--",
				"@--ii---",
				" -E--E* ",
				" -=##=- ",
				"  ----  "
			],
			[ // 20 Diamond
				"  --  ",
				" *-f- ",
				"-if@f-",
				"-f-f--",
				" -f-- ",
				"  --  "
			],
			[ // 21 Around the Clock
				" e -%- ",
				"-F-e =w",
				"i#F--=*",
				"e#@F-- ",
				" -i-   "
			],
			[ // 22 Just A Round
				"--@ e-",
				"-- ---",
				"F=-% *",
				"-- -i-",
				"- F  i",
				"-- --i",
				"-=----"
			],
			[ // 23 G
				"-i-i-i@",
				"f      ",
				"--=-f-%",
				"- i  #w",
				"f-=i--*",
				"- #W# f",
				"-f--i--"
			],
			[ // 24 Four Squares
				"  -w-  ",
				"  - -  ",
				"-@=*=-f",
				"- -%- -",
				"f-=-=e-",
				"  - -  ",
				"  ---  "
			],
			[ // 25 Big Diamond
				"   --   ",
				"  ffff  ",
				" --  -- ",
				"---@*---",
				"-----==-",
				" ffffff ",
				"  ----  ",
				"   --   "
			],
			[ // 26 First To The Switch
				"   @   ",
				"-i-- f%",
				"-===---",
				" - =e--",
				"e- =  -",
				"i-f*-e=",
				"-- =f -",
				"  e=-i-"
			],
			[ // 27 Big Square
				"--=*%--@",
				"- -w ---",
				"- -=-ii-",
				"-w-= --i",
				"-- e   -",
				"-  -- --",
				"- -----f",
				"-f- -- -",
				"-==f-f--"
			],
			[ // 28 Heart
				" ---f   ",
				"e---=%  ",
				"i-e---- ",
				"--i-*-f-",
				" f-i@--=",
				"-=--i---",
				"f----e- ",
				"--f---  ",
				" e---   "
			],
			[ // 29 Big Round To The Switch
				"   ---  ",
				"ef-=ef  ",
				"- -=ii- ",
				"i-=-  i ",
				"-==-- i ",
				" fe -== ",
				"--fe-%e ",
				"i-i=e -*",
				"---=-  -",
				"-==e-f-@"
			],
			[ // 30 Escape
				"   *   ", // put spaceship here
				"   -   ",
				"--eee-%",
				"- -----",
				"e   --e",
				"--===e-",
				"--- e--",
				"-e-@---"
			],
		];
	}

	init(data)
	{
		this.parameter = data;
	}

	preload()
	{
		this.load.image("sky", require("../assets/sky.jpg"));
		this.load.image("particle", require("../assets/bomb.png"));

		// platforms:
		this.load.spritesheet("platforms", require("../assets/platforms.png"), { frameWidth: 50, frameHeight: 40 });

		// player:
		this.load.spritesheet("player", require("../assets/player-sheet.png"), { frameWidth: 50, frameHeight: 40 });

		// enemies and objects:
		this.load.spritesheet("things", require("../assets/things.png"), { frameWidth: 50, frameHeight: 40 });

		// sounds:
		this.load.audio("sound-click", require("../assets/sounds/click.mp3"));
		this.load.audio("sound-eat", require("../assets/sounds/eat.mp3"));
		this.load.audio("sound-fall", require("../assets/sounds/fall.mp3"));
		this.load.audio("sound-fire", require("../assets/sounds/fire.mp3"));
		this.load.audio("sound-ice", require("../assets/sounds/ice.mp3"));
		this.load.audio("sound-teleport", require("../assets/sounds/teleport.mp3"));
		this.load.audio("sound-win", require("../assets/sounds/win.mp3"));
	}

	startLevel(gameScene, newNumber, newLevelData)
	{
		var x;
		var y;

		this.gameState = -1;
		this.destroyAt = 0;
		this.levelNumber = newNumber;
		this.levelWidth = newLevelData[0].length;
		this.levelHeight = newLevelData.length;
		this.levelLeft = (500 - (this.levelWidth * 50)) / 2 + 25;
		this.levelTop = (500 - (this.levelHeight * 40)) / 2 + 20;

		this.levelData = new Array(this.levelWidth);
		y = this.levelWidth;
		while (y--)
		{
			this.levelData[this.levelWidth - 1 - y] = new Array(this.levelHeight);
		}
		for (y = 0; y < this.levelHeight; y++)
		{
			for (x = 0; x < this.levelWidth; x++)
			{
				var p = new Platform(gameScene, x, y, newLevelData[y][x]);
				this.levelData[x][y] = p;
				if (p.typeKey == "@")
				{
					this.player.moveTo(x, y);
				}
				else if (p.type == 20)
				{
					this.platformEmitter.setPosition(this.levelLeft + x * 50, this.levelTop + y * 40 +15);
				}
				if (p.thing != 0)
				{
					var t = new Thing(gameScene, x, y, p.thing);
					t.anims.play("thing-" + t.type + "-idle");
					if (t.type == 1 || t.type == 2)
					{
						t.anims.nextTick = Phaser.Math.Between(0, 500);
					}
					this.things.add(t);
				}
			}
		}

		this.gameState = 0;
		this.player.status = 0; // idle
		this.player.anims.play("player-idle");
	}

	go(dx, dy)
	{
		if (this.gameState != 0) return;

		if (this.player.status == 0)
		{
			this.player.status = 1;
			this.player.dX = dx;
			this.player.dY = dy;
			this.player.anims.play("player-go-" + dx + "" + dy, true);

			var ld = this.levelData[this.player.currentX][this.player.currentY];
			switch (ld.type)
			{
				case 1:
				case 3:
					{
						// normal block, ice: remove
						ld.state = 0;
						//ld.setVisible(false);
						this.add.tween({
							targets: [ ld ],
							ease: "Sine.easeInOut",
							duration: 400,
							delay: 0,
							alpha: { getStart: () => 1, getEnd: () => 0 }
						});

						for (var i = this.things.children.entries.length - 1; i >= 0; i--)
						{
							var lde = this.things.children.entries[i];
							if (lde.active && lde.currentX == this.player.currentX && lde.currentY == this.player.currentY && lde.type == 5)
							{
								lde.destroy();
								break;
							}
						}
					}
					break;
				case 2:
					{
						// twice block: to normal
						ld.type = 1;
						ld.state = 1;
						ld.anims.play("platform-2-to-1", true);
					}
					break;
			}
		}
	}

	clickPlatform(platform)
	{
		var relX = platform.platformX - this.player.currentX;
		var relY = platform.platformY - this.player.currentY;
		var relSum = relX + relY;
		if ((relX == 0 || relY == 0) && (relSum == 1 || relSum == -1))
		{
			this.go(relX, relY); // jump 1 up|down|left|right
		}
	}

	die(time, anim)
	{
		this.player.anims.play(anim);
		this.gameState = 2;
		this.gameStateInfo = anim;
		this.gameStateAt = time + 750;
		this.cameras.main.fadeOut(750, 75, 25, 25);
	}

	animArray(key, indexes)
	{
		var array = [];
		for (var i = 0; i < indexes.length; i++)
		{
			if (i == indexes.length - 1 || indexes[i + 1] >= 0)
			{
				array.push( { key: key, frame: indexes[i] });
			}
			else
			{
				array.push( { key: key, frame: indexes[i], duration: -indexes[++i] }); // next item is duration with negative sign
			}
		}
		return array;
	}

	create()
	{
		var self = this;
		this.model = this.sys.game.globals.model;

		this.levelNumber = (this.parameter && this.parameter.level) ? this.parameter.level : 1;

		this.anims.create({ key: "player-idle", frames: [{ key: "player", frame: 0 }], frameRate: 20 });
		this.anims.create({ key: "player-go-10", frames: this.anims.generateFrameNumbers("player", { start: 16, end: 19 }), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "player-go--10", frames: this.anims.generateFrameNumbers("player", { start: 20, end: 23 }), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "player-go-0-1", frames: this.anims.generateFrameNumbers("player", { start: 24, end: 27 }), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "player-go-01", frames: this.anims.generateFrameNumbers("player", { start: 28, end: 31 }), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "player-killed", frames: this.anims.generateFrameNumbers("player", { start: 12, end: 15 }), frameRate: 7, repeat: 0 });
		this.anims.create({ key: "player-fire", frames: this.anims.generateFrameNumbers("player", { start: 8, end: 11 }), frameRate: 7, repeat: 0 });
		this.anims.create({ key: "player-fall", frames: [{ key: "player", frame: 29 }], frameRate: 20 });
		
		this.anims.create({ key: "platform-1", frames: this.animArray("platforms", [ 0 ]), frameRate: 20, repeat: 0 });
		this.anims.create({ key: "platform-2", frames: this.animArray("platforms", [ 1 ]), frameRate: 20, repeat: 0 });
		this.anims.create({ key: "platform-2-to-1", frames: this.animArray("platforms", [ 2, 3, 0 ]), frameRate: 5, repeat: 0 });
		this.anims.create({ key: "platform-ice", frames: this.animArray("platforms", [ 5, -725, 6, 7, 6 ]), frameRate: 5, repeat: -1 });
		this.anims.create({ key: "platform-fix", frames: this.animArray("platforms", [ 4 ]), frameRate: 20, repeat: 0 });
		this.anims.create({ key: "platform-exit", frames: this.animArray("platforms", [ 8 ]), frameRate: 20, repeat: 0 });

		this.anims.create({ key: "thing-1-idle", frames: this.animArray("things", [ 0, -1000, 1 ]), frameRate: 5, repeat: -1 });
		this.anims.create({ key: "thing-2-idle", frames: this.animArray("things", [ 0, -1000, 1 ]), frameRate: 5, repeat: -1 });
		this.anims.create({ key: "thing-1-hide", frames: this.animArray("things", [ 24, 25, 26, 27, 26 ]), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "thing-2-hide", frames: this.animArray("things", [ 24, 25, 26, 27, 26 ]), frameRate: 10, repeat: 0 });
		this.anims.create({ key: "thing-2-go-10", frames: this.anims.generateFrameNumbers("things", { start: 15, end: 12 }), frameRate: 5, repeat: 0 });
		this.anims.create({ key: "thing-2-go--10", frames: this.anims.generateFrameNumbers("things", { start: 8, end: 11 }), frameRate: 5, repeat: 0 });
		this.anims.create({ key: "thing-3-idle", frames: this.animArray("things", [ 16, -2000, 17, 18, 17, 16, -250, 19, 20, 19 ]), frameRate: 5, repeat: -1 });
		this.anims.create({ key: "thing-5-idle", frames: [{ key: "things", frame: 28 }], frameRate: 20, repeat: -1 });
		this.anims.create({ key: "thing-5-action", frames: this.animArray("things", [ 29, 30, 31, 30, 31, 29, 30, 31, 28 ]), frameRate: 8, repeat: 0 });

		this.anims.create({ key: "speaker-all", frames: [{ key: "things", frame: 5 }], frameRate: 20 });
		this.anims.create({ key: "speaker-mute", frames: [{ key: "things", frame: 6 }], frameRate: 20 });
		this.anims.create({ key: "speaker-sounds", frames: [{ key: "things", frame: 7 }], frameRate: 20 });

		this.add.image(0, 16.6 * (this.levelNumber - 1) - 500, 'sky').setOrigin(0, 0); // y depends on levelNumber (0..-500)

		var particles = this.add.particles("particle");
		this.platformEmitter = particles.createEmitter({
			speed: 20,
			scale: { start: 1, end: 0 },
			blendMode: "ADD",
			angle: { min: 0, max: 180 },
			tint: 0xDD3300
			//tint: 0x33DD00
		});
		this.platformEmitter.depth = 2;

		this.things = this.add.group();

		this.player = new Player(this, 0, 0);
		this.player.depth = 3;

		this.cursors = this.input.keyboard.createCursorKeys();
		this.input.keyboard.on("keydown-SPACE", this.keyPress);
		this.input.keyboard.on("keydown-ENTER", this.keyPress);
		this.input.keyboard.on("keydown-ESC", this.keyPress);
		this.input.keyboard.on("keydown-R", this.keyPress);
		this.input.keyboard.on("keydown-W", this.keyPress);
		this.input.keyboard.on("keydown-S", this.keyPress);
		this.input.keyboard.on("keydown-A", this.keyPress);
		this.input.keyboard.on("keydown-D", this.keyPress);
		this.input.keyboard.on("keydown-M", this.keyPress);
		this.input.keyboard.on("keydown-N", this.keyPress);

		//this.input.on("pointerdown", function(pointer) { self.pointerPress(pointer); });

		// this.input.on("gameobjectup", function (pointer, gameObject)
    	// {
        // 	gameObject.emit("clicked", gameObject);
		// }, this);
		
		this.startLevel(this, this.levelNumber, this.levelList[this.levelNumber - 1]);

		// HUD

		var hudAlpha = this.add.graphics();
		hudAlpha.fillStyle(0x222222, .75);
		hudAlpha.fillRect(0, 0, 500, 40);

		var levelNumberText = this.make.text({
			x: 15,
			y: 10,
			text: "#" + this.levelNumber,
			style: this.getTextStyleConfig(20, "#ffffff", "left")
		});
		levelNumberText.setInteractive({ useHandCursor: true});
		levelNumberText.on("pointerdown", () => this.scene.restart( { level: this.levelNumber, restart: true }));

		this.speakerIcon = this.add.sprite(250, 20, "things");
		this.updateSpeakerIcon();
		this.speakerIcon.setInteractive({ useHandCursor: true });
		this.speakerIcon.on("pointerdown", () => self.speakerPointerDown(), self);

		var quitButton = this.make.text({
			x: 430,
			y: 10,
			text: "QUIT",
			style: this.getTextStyleConfig(20, "#ffffff", "left")
		});
		quitButton.setInteractive({ useHandCursor: true });
		quitButton.on("pointerdown", () => this.scene.start("levelScene", { state: "quit", level: this.levelNumber }), this);

		this.notificationPopup = this.add.group();
		this.notificationPopup.depth = 999;

		// start with fade in

		this.cameras.main.fadeIn(500);

		if (this.levelNumber == 1 && (!this.parameter || !this.parameter.restart))
		{
			this.showNotification(0);
		}

		//this.sound.add("sound-click");
		//this.sound.add("sound-eat");
		//this.sound.add("sound-fall");
		//this.sound.add("sound-fire");
		//this.sound.add("sound-ice");
		//this.sound.add("sound-teleport");
		//this.sound.add("sound-win");
	}

	showNotification(index)
	{
		var self = this;
		this.lastNotificationIndex = index;
		this.gameState = 3;
		//this.notificationPopup.clear(true);
		for (var i = this.notificationPopup.children.entries.length - 1; i >= 0; i--)
		{
			this.notificationPopup.children.entries[i].destroy();
		}
		var height = this.notificationList[index][3];

		var bg = this.add.graphics();
		bg.fillStyle(0x222222, .9);
		bg.fillRect(25, 80, 450, 20 + height * 18);
		this.notificationPopup.add(bg);
		bg.depth = 999;

		var text = this.make.text({
			x: 250,
			y: 90,
			text: this.notificationList[index][4],
			style: this.getTextStyleConfig(15, "#ffffff", "center")
		}).setOrigin(0.5, 0);
		this.notificationPopup.add(text);
		text.depth = 999;

		var bgButton = this.add.graphics();
		bgButton.fillStyle(0x222222, .8);
		bgButton.fillRect(200, 105 + height * 18, 100, 42);
		this.notificationPopup.add(bgButton);
		bgButton.depth = 999;
		bgButton.setInteractive({ useHandCursor: true, hitArea: new Phaser.Geom.Rectangle(200, 105 + height * 18, 100, 42), hitAreaCallback: Phaser.Geom.Rectangle.Contains });
		bgButton.on("pointerup", function(p, x, y, event) { event.stopPropagation(); self.hideNotification(); });

		var okButton = this.make.text({
			x: 250,
			y: 110 + height * 18,
			text: "OK",
			style: this.getTextStyleConfig(32, "#ffffff", "center")
		}).setOrigin(0.5, 0);
		this.notificationPopup.add(okButton);
		okButton.depth = 999;
		//okButton.setInteractive({ useHandCursor: true });
		//okButton.on("pointerup", function(p, x, y, event) { self.hideNotification(); event.stopPropagation(); });
		//okButton.on("pointerover", () => okButton.setStyle({ color: "#ffff88"}));
		//okButton.on("pointerout", () => okButton.setStyle({ color: "#ffffff"}));
		//bgButton.on("pointerover", () => okButton.setStyle({ color: "#ffff88"}));
		//bgButton.on("pointerout", () => okButton.setStyle({ color: "#ffffff"}));
	}

	hideNotification()
	{
		this.model.playSound(this, "sound-click");
		for (var i = this.notificationPopup.children.entries.length - 1; i >= 0; i--)
		{
			//this.notificationPopup.children.entries[i].removeInteractive();
			this.notificationPopup.children.entries[i].destroy();
		}
		//this.notificationPopup.clear(true);
		this.gameState = 0;

		if (this.lastNotificationIndex < 3)
		{
			this.showNotification(this.lastNotificationIndex + 1);
		}
	}

	getTextStyleConfig(size, color, align)
	{
		return { fontFamily: "Aldrich, monospace, Constantia, Arial, sans-serif", fontSize: size + "px", color: color, align: align };
	}

	pointerPress(pointer)
	{
		var s = this;
		if (s.gameState == 0 && pointer.y > 40 && s.player.status == 0)
		{
			var rx = pointer.x - 250;
			var ry = pointer.y - 270;
			var ax = Math.abs(rx);
			var ay = Math.abs(ry);
			if (ry <= 0 && ax <= ay) s.go(0, -1);
			else if (ry >= 0 && ax <= ay) s.go(0, 1);
			else if (rx <= 0 && ax >= ay) s.go(-1, 0);
			else if (rx >= 0 && ax >= ay) s.go(1, 0);
		}
	}

	speakerPointerDown()
	{
		var soundsVolume = this.model.soundVolume;
		var musicVolume = this.model.musicVolume;
		if (soundsVolume > 0 && musicVolume > 0)
		{
			this.model.volume = 0;
		}
		else if (soundsVolume > 0)
		{
			this.model.volume = 1;
		}
		else
		{
			this.model.soundVolume = 1;
			this.model.musicVolume = 0;
		}
		this.updateSpeakerIcon();
	}

	updateSpeakerIcon()
	{
		var soundsVolume = this.model.soundVolume;
		var musicVolume = this.model.musicVolume;
		if (soundsVolume == 0 && musicVolume == 0)
		{
			this.speakerIcon.anims.play("speaker-mute");
		}
		else if (musicVolume == 0)
		{
			this.speakerIcon.anims.play("speaker-sounds");
		}
		else
		{
			this.speakerIcon.anims.play("speaker-all");
		}
	}

	keyPress(keyEvent)
	{
		var s = this.scene;
		if (s.gameState == 3 && (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.SPACE || keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.ENTER))
		{
			s.hideNotification();
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.ESC)
		{
			s.scene.start("levelScene", { state: "quit", level: s.levelNumber });
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.R)
		{
			s.scene.restart( { level: s.levelNumber, restart: true });
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.M)
		{
			s.model.volume = 1 - s.model.volume;
			s.updateSpeakerIcon();
		}
		else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.N)
		{
			s.model.soundVolume = 1;
			s.model.musicVolume = 0;
			s.updateSpeakerIcon();
		}
		else if (s.gameState == 0 && s.player.status == 0)
		{
			if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.W) s.go(0, -1);
			else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.S) s.go(0, 1);
			else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.A) s.go(-1, 0);
			else if (keyEvent.keyCode == Phaser.Input.Keyboard.KeyCodes.D) s.go(1, 0);
		}
	}

	update(time, delta)
	{
		var pointer = this.input.activePointer;

		// 0=play
		if (this.gameState == 0)
		{
			if (this.destroyAt != 0 && time >= this.destroyAt)
			{
				this.destroyAt = 0;
				for (var i = this.things.children.entries.length - 1; i >= 0; i--)
				{
					var lde = this.things.children.entries[i];
					if (lde.type == 1 || lde.type == 2)
					{
						lde.destroy();	
					}
				}
			}

			for (var i = this.things.children.entries.length - 1; i >= 0; i--)
			{
				var lde = this.things.children.entries[i];
				if (lde.active && (lde.type == 2 || lde.type == 5))
				{
					lde.update(time, delta);
				}
			}

			if (this.player.status == 1) // moving
			{
				if (this.player.anims.isPlaying)
				{
					this.player.x += this.player.dX * delta * 0.12;
					this.player.y += this.player.dY * delta * 0.1;
				}
				else
				{
					this.player.status = 0;
					this.player.currentX += this.player.dX;
					this.player.currentY += this.player.dY;
					this.player.moveTo(this.player.currentX, this.player.currentY);
					this.player.anims.play("player-idle");

					if (this.player.currentX < 0 || this.player.currentX >= this.levelWidth || this.player.currentY < 0 || this.player.currentY >= this.levelHeight)
					{
						this.die(time, "player-fall");
						this.model.playSound(this, "sound-fall");
						return;
					}
					var ld = this.levelData[this.player.currentX][this.player.currentY];
					if (ld.state == 0)
					{
						this.die(time, "player-fall");
						this.model.playSound(this, "sound-fall");
						return;
					}
					else if (ld.type == 3)
					{
						// ice
						var iceDX = this.player.dX;
						var iceDY = this.player.dY;
						//if (iceDX > 1) iceDX = 1;
						//if (iceDX < -1) iceDX = -1;
						//if (iceDY > 1) iceDY = 1;
						//if (iceDY < -1) iceDY = -1;
						this.go(iceDX, iceDY);
						this.model.playSound(this, "sound-ice");
						return;
					}
					else if (ld.type == 20)
					{
						// check for success
						var hasRemaining = false;
						for (var x = 0; x < this.levelWidth; x++)
						{
							for (var y = 0; y < this.levelHeight; y++)
							{
								var ldw = this.levelData[x][y];
								if (ldw.state > 0 && (ldw.type == 1 || ldw.type == 2 || ldw.type == 3))
								{
									hasRemaining = true;
									break;
								}
							}
							if (hasRemaining)
							{
								break;
							}
						}
						if (!hasRemaining)
						{
							this.gameState = 1;
							this.gameStateAt = time + 500;
							this.cameras.main.fadeOut(500);
							return;
						}
					}
					for (var i = this.things.children.entries.length - 1; i >= 0; i--)
					{
						var lde = this.things.children.entries[i];
						if (lde.active && lde.currentX == this.player.currentX && lde.currentY == this.player.currentY)
						{
							if (lde.type == 1 || lde.type == 2)
							{
								lde.destroy();
								this.die(time, "player-killed");
								this.model.playSound(this, "sound-eat");
								return;
							}
							else if (lde.type == 3)
							{
								this.destroyAt = time + 500;
								for (var j = this.things.children.entries.length - 1; j >= 0; j--)
								{
									var ldee = this.things.children.entries[j];
									if (ldee.type == 1 || ldee.type == 2)
									{
										ldee.anims.play("thing-" + ldee.type + "-hide");
										//ldee.event.once(Phaser.Animations.Events.SPRITE_ANIMATION_COMPLETE, () => { this.destroy(); });
									}
								}
								lde.destroy();
								this.model.playSound(this, "sound-teleport");
							}
						}
					}
					for (var i = 0; i < this.notificationList.length; i++)
					{
						if (this.notificationList[i][0] == this.levelNumber && this.notificationList[i][1] == this.player.currentX && this.notificationList[i][2] == this.player.currentY)
						{
							this.showNotification(i);
							break;
						}
					}
				}
			}
			else if (this.player.status == 0)
			{
				if (this.cursors.right.isDown)
				{
					this.go(+1, 0);
				}
				else if (this.cursors.left.isDown)
				{
					this.go(-1, 0);
				}
				else if (this.cursors.up.isDown)
				{
					this.go(0, -1);
				}
				else if (this.cursors.down.isDown)
				{
					this.go(0, +1);
				}
				else if (pointer.isDown)
				{
					this.pointerPress(pointer);
				}
			}
		}
		else if (this.gameState == 1)
		{
			if (time >= this.gameStateAt)
			{
				this.model.playSound(this, "sound-win");
				this.scene.start("levelScene", { state: "win", level: this.levelNumber });
			}
		}
		else if (this.gameState == 2)
		{
			if (time >= this.gameStateAt)
			{
				this.scene.restart( { level: this.levelNumber, restart: true });
			}
			else
			{
				if (this.gameStateInfo == "player-fall")
				{
					this.player.y += delta * 0.05;
				}
			}
		}
	}

	end()
	{
	}
}

class Player extends Phaser.GameObjects.Sprite
{
	constructor(gameScene, cx, cy)
	{
		super(gameScene, gameScene.levelLeft + cx * 50, gameScene.levelTop + cy * 40 - 15, "player");
		gameScene.add.existing(this);

		this.currentX = cx;
		this.currentY = cy;
		this.status = 0; // 0: idle, 1: moving
		this.dX = 0;
		this.dY = 0;
	}

	moveTo(x, y)
	{
		this.currentX = x;
		this.currentY = y;
		this.x = this.scene.levelLeft + x * 50;
		this.y = this.scene.levelTop + y * 40 - 15;
	}
}

class Thing extends Phaser.GameObjects.Sprite
{
	constructor(gameScene, cx, cy, ctype)
	{
		super(gameScene, gameScene.levelLeft + cx * 50, gameScene.levelTop + cy * 40 - 15, "thing-" + ctype);
		gameScene.add.existing(this);
		this.depth = 2;

		this.type = ctype;
		this.status = 0;
		this.nextActionAt = 0;
		this.currentX = cx;
		this.currentY = cy;
		this.dX = 0;
		this.dY = 0;

		if (ctype == 2)
		{
			this.status = 1; // ready to move
			this.nextActionAt = Phaser.Math.Between(500, 1500);
			this.dX = Phaser.Math.Between(1, 2) == 1 ? 1 : -1;
		}
		if (ctype == 5)
		{
			this.status = 0; // ready to fire
			this.nextActionAt = cx * 200 + cy * 150; // something predictable
		}
	}

	moveTo(x, y, time)
	{
		this.currentX = x;
		this.currentY = y;
		this.x = this.scene.levelLeft + x * 50;
		this.y = this.scene.levelTop + y * 40 - 15;
		if (this.type == 2 && this.scene.player.currentX == x && this.scene.player.currentY == y)
		{
			this.visible = false;
			this.scene.die(time, "player-killed");
			this.scene.model.playSound(this.scene, "sound-eat");
		}
	}

	update(time, delta)
	{
		/*if ((this.type == 1 || this.type == 3) && this.state == 0 && this.visible)
		{
			this.alpha -= delta * 0.05;
			if (this.alpha <= 0)
			{
				this.visible = false;
			}
		}*/
		if (this.type == 2)
		{
			if (this.status == 1 && time >= this.nextActionAt)
			{
				this.nextActionAt = time + 2000;
				var tX = this.currentX + this.dX;
				if (tX >= this.scene.levelWidth || tX < 0 || this.scene.levelData[tX][this.currentY].state == 0)
				{
					this.dX = -this.dX;
				}
				tX = this.currentX + this.dX;
				if (tX < this.scene.levelWidth && tX >= 0 && this.scene.levelData[tX][this.currentY].state != 0)
				{
					this.status = 2; // jumping
					this.anims.play("thing-2-go-" + this.dX + "0");
				}
			}
			else if (this.status == 2)
			{
				if (this.anims.isPlaying)
				{
					this.x += this.dX * delta * 0.06;
				}
				else
				{
					this.status = 1;
					this.anims.play("thing-2-idle");
					this.moveTo(this.currentX + this.dX, this.currentY, time);
				}
			}
		}
		else if (this.type == 5)
		{
			if (this.status == 0)
			{
				this.nextActionAt += time;
				this.status = 1;
			}
			else if (this.status == 2 && this.scene.player.currentX == this.currentX && this.scene.player.currentY == this.currentY)
			{
				this.visible = false;
				this.scene.die(time, "player-fire");
				this.scene.model.playSound(this.scene, "sound-fire");
			}
			else if (this.status == 1 && time >= this.nextActionAt)
			{
				this.status = 2;
				this.nextActionAt = time + 1000;
				this.anims.play("thing-5-action");
			}
			else if (this.status == 2 && time >= this.nextActionAt)
			{
				this.status = 1;
				this.nextActionAt = time + 2000;
				this.anims.play("thing-5-idle");
			}
		}
	}
}

class Platform extends Phaser.GameObjects.Sprite
{
	constructor(gameScene, cx, cy, ctype)
	{
		var type = 1;
		var state = 1;
		var thing = 0;

		switch (ctype)
		{
			case " ": type = 0; state = 0; break; // empty 
			case "-": type = 1; break;  // normal
			case "=": type = 2; break; // twice
			case "i": type = 3; break; // ice
			case "#": type = 4; break; // fix
			//case "b": type = 1; thing = 4; break; // boots on normal
			case "%": type = 1; thing = 3; break; // switch on normal
			case "e": type = 1; thing = 1; break; // enemy 1 on normal
			case "E": type = 4; thing = 1; break; // enemy 1 on fix
			case "w": type = 1; thing = 2; break; // enemy 2 on normal
			case "W": type = 4; thing = 2; break; // enemy 2 on fix
			case "f": type = 1; thing = 5; break; // fire on normal
			case "F": type = 4; thing = 5; break; // fire on fix
			case "@": type = 1; break; // normal (start)
			case "*": type = 20; break; // finish
		}

		super(gameScene, gameScene.levelLeft + cx * 50, gameScene.levelTop + cy * 40, "platforms");
		gameScene.add.existing(this);

		this.platformX = cx;
		this.platformY = cy;
		this.state = state;
		this.type = type;
		this.typeKey = ctype;
		this.thing = thing;

		if (ctype == " ")
		{
			this.setVisible(false);
		}
		else
		{
			//this.setInteractive();
			//this.on("clicked", gameScene.clickPlatform, gameScene);
			if (type == 2)
			{
				this.anims.play("platform-2");
			}
			else if (type == 3)
			{
				this.anims.play("platform-ice");
			}
			else if (type == 4)
			{
				this.anims.play("platform-fix");
			}
			else if (type == 20)
			{
				this.anims.play("platform-exit");
			}
		}
	}
}

export default GameScene;